import React from 'react'
import { useOutletContext } from 'react-router-dom'
import { Typography, Flex, Alert, message } from 'antd'
import { FormBuilder } from '@/components/FormBuilder'
import { deleteStep } from '@/api/lop/lead-flows/deleteStep'
import { getErrorMessage } from '@/utils/getErrorMessage'
import type { FlowEditorContext } from '../../index'

const { Title, Text } = Typography

export const FormBuilderPage: React.FC = () => {
  const {
    selectedTemplate,
    getTemplateState,
    setTemplateState,
    flowSlug,
    mode,
    branding,
    setBranding,
    brandingEnabled,
    setBrandingEnabled,
    promptVersion,
    setPromptVersion,
  } = useOutletContext<FlowEditorContext>()

  if (!selectedTemplate) {
    return (
      <Alert
        title="No Template Selected"
        description="Please go back and select a template first before configuring form steps."
        type="info"
        showIcon
      />
    )
  }

  return (
    <div>
      <Flex vertical gap="large" style={{ width: '100%' }}>
        <div>
          <Title level={4}>Form Builder</Title>
          <Text type="secondary">
            Configure the multi-step form for your lead flow.
          </Text>
        </div>

        <FormBuilder
          template={selectedTemplate}
          state={getTemplateState(selectedTemplate)}
          onChange={setTemplateState}
          branding={branding}
          onBrandingChange={setBranding}
          brandingEnabled={brandingEnabled}
          onBrandingToggle={setBrandingEnabled}
          promptVersion={promptVersion}
          onPromptVersionChange={setPromptVersion}
          onDeleteStep={
            mode === 'edit' && flowSlug
              ? (stepId) => {
                  deleteStep(flowSlug, stepId).catch((err) => {
                    message.error(getErrorMessage(err, 'Failed to delete step'))
                  })
                }
              : undefined
          }
        />
      </Flex>
    </div>
  )
}
